import useFetchAgencyIntegrationSettings from 'components/domain/integrationSettings/useFetchAgencyIntegrationSettings';
import { Affiliate } from 'models/Integrations';

const useIsPropertyGuidebookEnabled = () => {
  const { integrationSettings } = useFetchAgencyIntegrationSettings();

  const hostfullyIntegrationSettings = integrationSettings?.find(
    ({ affiliateEnum }) => affiliateEnum === Affiliate.HOSTFULLY,
  );

  const { isEnabled } = hostfullyIntegrationSettings || {};

  return !!isEnabled;
};

export default useIsPropertyGuidebookEnabled;
